var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoAnalyticYet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 109,
    viewBox: "0 0 122 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1569"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background circle",
    cx: 60,
    cy: 52,
    r: 52,
    fill: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Circle",
    cx: 5,
    cy: 11,
    r: 5,
    fill: "#EDF4FB"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Circle_2",
    cx: 12,
    cy: 102,
    r: 7,
    fill: "#EDF4FB"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Circle_3",
    cx: 118,
    cy: 8,
    r: 4,
    fill: "#EDF4FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Exp-3.-G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0735 48.9961L56.582 66.4859C56.582 66.4859 62.8022 64.5433 71.7417 67.6517C73.2456 68.1745 75.7621 65.658 75.2393 64.1541C72.1309 55.2146 74.0735 48.9961 74.0735 48.9961Z",
    fill: "url(#paint0_linear_11857_7624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2605 19.6785C37.8804 9.06029 55.1211 9.06029 65.741 19.6785C76.3592 30.2983 76.3592 47.5391 65.741 58.159C55.1211 68.7772 37.8804 68.7772 27.2605 58.159C16.6423 47.5391 16.6423 30.2983 27.2605 19.6785Z",
    fill: "url(#paint1_linear_11857_7624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2253 16.707C63.4588 17.5827 64.6362 18.5738 65.7427 19.6786C76.3609 30.2985 76.3609 47.5392 65.7427 58.1591C55.1228 68.7773 37.8821 68.7773 27.2622 58.1591C26.6372 57.5324 26.0485 56.8844 25.4961 56.2165C35.7894 59.5608 47.5537 57.1466 55.7264 48.9739C64.4432 40.257 66.6101 27.4539 62.2253 16.707Z",
    fill: "#E5EEF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9296 17.3436C36.8357 5.43754 56.1674 5.43754 68.0735 17.3436C79.9796 29.2497 79.9796 48.5815 68.0735 60.4876C56.1674 72.3937 36.8357 72.3937 24.9296 60.4876C13.0235 48.5815 13.0235 29.2497 24.9296 17.3436ZM28.4272 20.8413C38.4023 10.8662 54.6008 10.8662 64.5759 20.8413C74.551 30.8163 74.551 47.0149 64.5759 56.99C54.6008 66.9651 38.4023 66.9651 28.4272 56.99C18.4521 47.0149 18.4521 30.8163 28.4272 20.8413Z",
    fill: "url(#paint2_linear_11857_7624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1695 52.481C13.51 41.0712 15.4295 26.8432 24.9297 17.3431C33.851 8.42176 46.9411 6.18566 57.9551 10.6348C58.0342 11.6456 58.0755 12.6697 58.0755 13.7037C58.0755 14.5018 58.0507 15.295 58.0029 16.0832C48.4203 11.2581 36.4251 12.8445 28.4273 20.8407C19.9495 29.3185 18.6765 42.2915 24.6114 52.1198C22.8733 52.3573 21.0989 52.481 19.2982 52.481H19.1695Z",
    fill: "url(#paint3_linear_11857_7624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4055 73.316C67.5081 70.4186 67.5081 65.7205 70.4055 62.8215C73.3028 59.9241 78.0026 59.9241 80.9 62.8215L104.805 86.726C105.448 87.3692 103.619 90.2434 100.723 93.1392C97.8274 96.0349 94.9531 97.8637 94.31 97.2205L70.4055 73.316Z",
    fill: "url(#paint4_linear_11857_7624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4055 73.316C67.5081 70.4186 67.5081 65.7205 70.4055 62.8215C73.3028 59.9241 78.0026 59.9241 80.9 62.8215L102.535 84.4569C103.179 85.1001 101.35 87.9744 98.4541 90.8701C95.5583 93.7658 92.684 95.5946 92.0409 94.9515L70.4055 73.316Z",
    fill: "url(#paint5_linear_11857_7624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0078 33.725C42.9699 32.1535 43.5603 31.0058 44.4705 30.333C45.9019 29.2776 48.0407 29.3221 49.2016 30.6298C49.6996 31.1921 49.9882 31.9869 49.9965 32.9929C50.0163 35.4054 48.885 36.8154 47.7769 38.2748C46.2861 40.2421 44.797 42.2638 44.6123 45.6394C44.5629 46.5497 45.2621 47.3264 46.1707 47.3758C47.0793 47.4253 47.8577 46.7278 47.9071 45.8191C48.0457 43.2549 49.2725 41.7608 50.4054 40.2668C51.9226 38.2665 53.3226 36.2712 53.2946 32.9665C53.2781 31.0239 52.63 29.5249 51.667 28.4399C49.4177 25.9069 45.2868 25.6332 42.5131 27.678C40.8509 28.9049 39.6421 30.9365 39.7097 33.8025C39.7312 34.7128 40.4881 35.4335 41.3984 35.412C42.307 35.3906 43.0293 34.6353 43.0078 33.725Z",
    fill: "url(#paint6_linear_11857_7624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M46.1064 53.502C47.2267 53.502 48.1348 52.5939 48.1348 51.4736C48.1348 50.3534 47.2267 49.4453 46.1064 49.4453C44.9862 49.4453 44.0781 50.3534 44.0781 51.4736C44.0781 52.5939 44.9862 53.502 46.1064 53.502Z",
    fill: "url(#paint7_linear_11857_7624)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.7837 10.7419L80.7309 2.49668C81.1992 1.71668 80.9469 0.702517 80.1652 0.234188C79.3852 -0.232491 78.3711 0.0198123 77.9028 0.799811L72.9556 9.04504C72.4873 9.82668 72.7412 10.8408 73.5212 11.3075C74.3029 11.7759 75.3154 11.5236 75.7837 10.7419Z",
    fill: "#AEC4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5873 16.1753L101.727 2.98299C102.462 2.44705 102.626 1.41475 102.091 0.679273C101.555 -0.0578501 100.523 -0.219456 99.7875 0.314834L81.648 13.5072C80.9109 14.0431 80.7493 15.0754 81.2836 15.8109C81.8195 16.548 82.8518 16.7096 83.5873 16.1753Z",
    fill: "#AEC4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3139 26.3359L99.5063 23.0379C100.39 22.8169 100.928 21.9214 100.707 21.0376C100.486 20.1553 99.5904 19.6177 98.7065 19.8387L85.5141 23.1368C84.6319 23.3578 84.0943 24.2532 84.3153 25.1371C84.5362 26.0193 85.4317 26.5569 86.3139 26.3359Z",
    fill: "#AEC4E1"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11857_7624",
    x1: 56.6421,
    y1: 57.0495,
    x2: 75.2967,
    y2: 63.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11857_7624",
    x1: 27.4271,
    y1: 23.6428,
    x2: 65.5332,
    y2: 58.3634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11857_7624",
    x1: 55.1252,
    y1: 13.1072,
    x2: 66.131,
    y2: 62.2719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11857_7624",
    x1: 29.7168,
    y1: 11.7116,
    x2: 43.582,
    y2: 53.9486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11857_7624",
    x1: 92.5967,
    y1: 74.5181,
    x2: 84.6136,
    y2: 89.8559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11857_7624",
    x1: 90.5073,
    y1: 72.4288,
    x2: 83.9903,
    y2: 86.9008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11857_7624",
    x1: 39.7081,
    y1: 26.3835,
    x2: 48.1347,
    y2: 53.5004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11857_7624",
    x1: 39.7082,
    y1: 26.3851,
    x2: 48.1348,
    y2: 53.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E69EF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAnalyticYet);
export default __webpack_public_path__ + "static/media/noAnalyticYet.418662b742d99083a00f296f3380a1dd.svg";
export { ForwardRef as ReactComponent };